import { Dispatch, SetStateAction, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { ListarCategoriaTipoCasoController } from "../../../../Controllers/Geral/Etapas/EtapasControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import EtapasDesvinculadasGrupo from "./EtapasDesvinculadas";
import EtapasVinculadasGrupo from "./EtapasVinculadas";

interface IEditarGrupoModalProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    idGrupo: number;
}

export default function EditarGrupoModal(props: IEditarGrupoModalProps) {
    const { id } = useModuloInfo();
    const { execute: update } = useAsyncCallback(
        () => ListarCategoriaTipoCasoController(id!),
        []
    );

    const [idCategoriaAtendimento, setIdCategoriaAtendimento] = useState(0);
    return (
        <>
            <LazySelect
                controller={update}
                getDS={(ca) => ca.DS_CATEGORIA_ATENDIMENTO}
                getKeyValue={(ca) => ca.ID_CATEGORIA_ATENDIMENTO}
                name="ID_CATEGORIA_ATENDIMENTO"
                label="Categoria Atendimento"
                value={idCategoriaAtendimento}
                onChange={(e) =>
                    setIdCategoriaAtendimento(Number(e.target.value))
                }
                className="form-control placeholder-dark-75 "
            >
                <option></option>
            </LazySelect>

            <hr />
            <Tabs defaultActiveKey="vinculadas" unmountOnExit>
                <Tab
                    title="Etapas Vinculadas"
                    eventKey="vinculadas"
                    mountOnEnter
                >
                    <div className="p-5">
                        <EtapasVinculadasGrupo
                            idGrupo={props.idGrupo}
                            idCategoriaAtendimento={idCategoriaAtendimento}
                        />
                    </div>
                </Tab>
                <Tab
                    title="Etapas Desvinculadas"
                    eventKey="desvinculadas"
                    mountOnEnter
                >
                    <div className="p-5">
                        <EtapasDesvinculadasGrupo
                            idGrupo={props.idGrupo}
                            idCategoriaAtendimento={idCategoriaAtendimento}
                        />
                    </div>
                </Tab>
            </Tabs>
        </>
    );
}
